import currency from "currency.js";
import {updateTotals} from "../common";
import {checkBox_html, formatCurrency} from "../../calcsys";
import tab from "bootstrap/js/src/tab";
import TomSelect from "tom-select/base";

// export let SlimSelectSettings = {
//     placeholderText: '...',
//     contentPosition: 'relative',
//     showOptionTooltips: true,
//     openPosition: 'auto', // 'auto', 'up' or 'down'
//     // contentLocation: document.getElementById('app')
// }

// export let SlimSelectEvents = {
//     beforeOpen: () => {
//         console.log('before open')
//     },
// }

export function createCol(data, tableData, nameSuffix = '' ){
    let sendToObserver = false
    let container = $('<div>')
        .addClass(tableData.class)

    let col = $('<input>')
        .attr('type', 'text')
        .val(data[tableData.name])


    if(tableData.type === 'plainText') {
        col = $('<div>')
            .html(data[tableData.name]??'')
            .addClass(tableData.inputClass)
    }

    if(tableData.type === 'select') {
        col = createSelect(tableData, data[tableData.name],  (a) => {

            if(tableData.name === 'note'){
                let v = tableData.options[a]

                let newOpts = CS.getSupportingData()['companyExpenses'][v]
                let ss = $('[name="noteDescr"]', col.parents()[1])[0].tomselect
                ss.clearOptions()
                for(let k in newOpts){
                    let x = {value: k, text: newOpts[k]}
                    ss.addOption(x)
                }

            }
        })
    }

    if(tableData.type === 'textarea') {
        col = $('<textarea>')
            .on('input', function (e) {
                CS.auto_grow(this)
            }).html(data[tableData.name])

        sendToObserver = {
            callback: function(){
                CS.auto_grow(col[0])
            },
            element: col[0]
        }
    }

    if(tableData.type === 'number') {
        col.attr('type', 'number')
    }

    if(tableData.type === 'date') {

        sendToObserver = {
            callback: function(){
                datepicker(col[0], CS.dpOptions)
            },
            element: col[0]

        }
    }

    if(tableData.type === 'currency') {
        col.addClass('currency ')
            .val(currency(data[tableData.name]).format())
            .on('keyup', updateTotals)
            .on('blur',  () => {
                let thisValue = currency(col.val())
                col.val(thisValue.format())
                CS.updateTaxes(col)
                CS.updateSums()
            })
            .on('focus', function () {
                var $this = $(this);
                $this.select();

                window.setTimeout(function () {
                    $this.select();
                }, 1);

                // Work around WebKit's little problem
                function mouseUpHandler() {
                    // Prevent further mouseup intervention
                    $this.off("mouseup", mouseUpHandler);
                    return false;
                }

                $this.mouseup(mouseUpHandler);

            });
    }

    col.attr('name', tableData.name+nameSuffix)
        .attr('data-name', tableData.name)

    if(tableData.type === 'check') {

        col.attr('type', 'checkbox')
            // .addClass('form-check-input')

        if(data[tableData.name])
            col.attr('checked', true)

        return container.append(checkBox_html(tableData.name+nameSuffix,false,false,col))

    }



    if(tableData.inputClass)
        col.addClass(tableData.inputClass)

    if(sendToObserver) CS.addToObserveList(sendToObserver)

    CS.startTrackingChanges(col);

    if(tableData.disabled){
        col.attr('disabled', 'disabled')
        let hcol = $('<input>')
            .attr('name', tableData.name+nameSuffix)
            .attr('type', 'hidden')
            .val(data[tableData.name])
        container.append(hcol)
    }

    if(tableData.type === 'button') {
        if(tableData.name === 'reorder'){
            col = $('<div>')
                .html('<i class="fa-solid fa-bars"></i>')
            // Sortable.create(col[0])

        }else
            col = $('<div>')
                .addClass('removeRow')
                .html('<i class="fa-solid fa-delete-left"></i>')
                .on('click',function () {
                    $(this).parent().parent().remove()
                })
    }
    // if(tableData.type === 'text') {
    //     col = $('<div>')
    //         // .addClass('removeRow')
    //         .html(data[tableData.name])
    //         .on('click',function () {
    //             $(this).parent().parent().remove();
    //         });
    // }

    return container.append(col)
}
function createSelect(data, origVal, selOnChange){
    if(data.name === 'projectNumber' && origVal) {
        origVal = parseFloat(origVal).toFixed(2)
    }

    let sel = $('<select>')
        .attr('name', data.name)
        .addClass(data.inputClass)

    if(data.multi)
        sel.attr('multiple', 'multiple')

    if(!data.tsSettings) {
        sel.append(
            $('<option value="">')
                .attr('data-placeholder', 'true')
                .html(data.placeholder ?? '')
        )
        let opts = data.options
        for (let value in opts) {
            let title = opts[value]

            if (title === null) {
                continue
            }
            let opt = $('<option>')
                .val(value)
                .html(title)
            // .attr('title', '???')
            if ((value === data.value || parseInt(data.value) === parseInt(value) || title === data.value) && title.length > 0) {
                opt.attr('selected', true)
            }
            if ((value === origVal || title === origVal) && origVal.length > 0) {
                opt.attr('selected', true)
            }

            sel.append(opt)
        }
    }
    if(data.name === 'customer'){
        selOnChange =  function(newVal) {

            let info = CS.getSupportingData()['customers'][newVal]

            if(!info) return
            $('[name="customerEmail"]').val(info.Email).trigger('change')
            $('[name="billingAddress"]').val(info.Address).trigger('change')
            CS.initValidations()
        }
    }

    sel.ready(() => {
        let ts = new TomSelect(sel,{...{
            onChange: (a) => {
                if(data.onChange) data.onChange(a)
                if(selOnChange) selOnChange(a)

                if(data.blankIsAll){
                    ts.settings.placeholder = ts.getValue().length > 0 ? '' : 'ALL'
                }
            },
                maxOptions: null,
                sortField : {               // ➊ activate alphabetical sort
                    field     : 'text',       // compare by the text shown in the list
                    direction : 'asc'         // ascending; use 'desc' for Z‑A
                },
                render: {
                    option: function(data, escape) {
                        const out = $('<div>')

                        out.append(
                            $('<span>').html(escape(data.text))
                        )
                        if(data.count){
                            out.append(
                                $('<span>').html(escape(data.count))
                                    .addClass('ms-auto')
                            )
                            out.addClass('hstack gap-1')
                        }
                        return out

                        // '<div class="hstack gap-1">' +
                        //     '<span class="">' + escape(data.text) + '</span>' +
                        //     '<span class="ms-auto">' + escape(data.count) + '</span>' +
                        //     '</div>';
                    },
                    // item: function(data, escape) {
                    //     return '<div title="' + escape(data.url) + '">' + escape(data.title) + '</div>';
                    // }
                }
            // options: [
                // { value: "opt1", text: "Option 1" },
                // { value: "opt2", text: "Option 2" },
            // ]
            // dropdownParent: 'body',
        },...(data.tsSettings ?? {})})

    })
    // CS.addToObserveList({
    //     callback: ()=>{
    //         let x = $('<div>').addClass('ssContentDiv')
    //         sel.parent().append(x)
    //         console.log('here?!!!')
    //
    //         // let z = startSelect(sel[0], {
    //         //     onChange: selOnChange,
    //         //     dropdownParent: 'body',
    //         // })
    //
    //     },
    //     element: sel[0],
    // })

    return sel
}
export function createFromInput(data, modifier){
    let out = $('<div>')
        .addClass(data.containerClass)

    let label = data.title ? $('<label>')
        .html(data.title) : null

    let inp = data.obj ?? $('<input>')
        .attr({name: data.name, type: 'text', value: data.value??'', 'autocomplete':"off"})
        .addClass(data.inputClass)

    if(data.type === 'plainText') {
        inp = $('<div>')
            .html(data.value??'')
            .addClass(data.inputClass)
    }

    if(modifier){
        inp = modifier(inp)
    }

    if(data.type === 'currency'){
        let v = data.value
        if(v > 0)
            v = currency(data.value).format()
        inp.addClass('currency')
            .attr('placeholder', 'N/A')
            .val(v)
            .on('keyup', updateTotals)
            .on('blur',  () => {
                if(inp.val() === '') return
                let thisValue = currency(inp.val())
                // console.log('vvv', inp.val())
                inp.val(thisValue.format())
                CS.updateTaxes(inp)
                // if ($(this).attr('name') === 'cost[]') {
                //     CS.updateTaxes($(this))
                // }
                CS.updateSums()
            })
            .on('focus', function () {
                var $this = $(this);
                $this.select();

                window.setTimeout(function () {
                    $this.select();
                }, 1);

                // Work around WebKit's little problem
                function mouseUpHandler() {
                    // Prevent further mouseup intervention
                    $this.off("mouseup", mouseUpHandler);
                    return false;
                }

                $this.mouseup(mouseUpHandler);

            });
    }
    if(data.type === 'select'){
        let sel = createSelect(data,null, (a,b) => {
            console.log('change sel', a,b)
            CS.initValidations()
        })
        CS.startTrackingChanges(sel);
        if(data.class)
            out.addClass(data.class)
        return out.append(label).append(sel)//.append(inp);
    }else{
        inp.addClass('form-control form-control-sm')
    }

    if(data.type === 'textarea'){
        inp = $('<textarea>')
            .attr('name', data.name)
            .addClass(data.inputClass)

        if(data.value)
            inp.html(data.value)
    }
    if(data.type === 'fullAddress'){

    }
    if(data.type === 'date'){

        // CS.addToObserveList({
        //     callback: function(){
        //         datepicker(inp[0], CS.dpOptions)
        //     },
        //     element: inp[0],
        // })

        inp.ready(() => {
            datepicker(inp[0], CS.dpOptions)
        })
    }
    if(data.type === 'files'){
        CS.initFileManagerBox(out)
    }else{

        out.append(label).append(inp)
    }

    if(data.inputID)
        inp.attr('id', data.inputID)

    return out
}
export function createInputFromColumn(obj, override = []){
    let out = $('<span>')
        .html(obj.fullName)
        .addClass('badge bg-dark m-1 ')

    let inp = $('<input>')
        .attr('value', obj.value)
        .addClass('p-1')

    if(obj.type === 'plainText') {
        inp = $('<div>')
            .html(data.value??'')
            .addClass(data.inputClass)
    }

    if(obj.subType?.includes('listdb:') || obj.subType?.includes('list:') || obj.subType2?.includes('listdb') || obj.subType2?.includes('list')){
        // inp.attr('type', 'hidden')
        let sel = $('<select>').attr('name', obj.shortName)
            .on('load', () => {
            // console.log('rdy?')
            // $(sel).selectize()
        })
        sel.append($('<option>').attr('data-placeholder', 'true'))
        // if(obj.subType?.includes('list:') || obj.subType2?.includes('list')) {
        //     obj.options = obj.subType.substring(5).split(',')
        //     for(var x in obj.options){
        //         let item = obj.options[x]
        //         let opt = $('<option>')
        //             .val(item)
        //             .html(item)
        //         if(item === obj.clean)
        //             opt.attr('selected', 'selected')
        //
        //         sel.append(opt)
        //     }
        //
        // }else{
            for(var x in obj.options){
                let item = obj.options[x]
                let opt = $('<option>')
                    .val(item.id ?? item)
                    .html(item.Name ?? item)
                if(parseInt(item.id) === parseInt(obj.clean))
                    opt.attr('selected', 'selected')
                else if(item === obj.clean)
                    opt.attr('selected', 'selected')
                sel.append(opt)
            }

        // }

        sel
            // .addClass('d-block text-center form-control form-control-sm')
            .addClass(obj.class)

        if(obj.width>0)
            sel.width(obj.width)

        CS.startTrackingChanges(sel);



        CS.addToObserveList({
            callback: () => {
                sel.trigger('change')
                // let x = $('<div>').addClass('ssContentDiv')
                // sel.parent().append(x)
                // console.log('here?')
                // $(sel).selectize()

                $('.taxable').each( () => {
                    CS.updateTaxes($(this))
                })


                // let z = startSelect(sel[0], {})
                // console.log('??',z)

                // startSelect({
                //     select: sel[0],
                //     settings: {...SlimSelectSettings, ...{
                //             contentLocation: x.get()[0],
                //             showSearch: obj.searchable??false,
                //         }},
                //     events: {...{
                //         beforeChange: (row) => {
                //             // console.log('change', opt, v, row)
                //             if(obj.shortName !== 'Vendor') return true;
                //             let v = row[0].value
                //             // inp.val(v)
                //             let opt = obj.options.find(x => x.UID === v)
                //             if(!opt) {console.log('no opt found', obj.options ,v); return; }
                //             let salesTax = opt.SalesTax??0
                //             if(override['vendorTaxRate'])
                //                 salesTax= parseFloat(override['vendorTaxRate'])
                //             $('.extraInputs .vendorTaxRate').val(salesTax+'%')
                //             $('.extraInputs .vendorAddress').val(opt.Address)
                //
                //             $('[name="cost"]').each(function (){
                //                 CS.updateTaxes($(this))
                //             })
                //             CS.updateSums()
                //
                //             return true
                //
                //         }
                //     }, ... SlimSelectEvents}
                // })
            },
            element: sel[0],
        })
        inp = sel;
        out.append(sel)

    }else{
        inp.attr('name', obj.shortName)
            .addClass('d-block text-center form-control form-control-sm')
            .addClass(obj.class)
            .width(obj.width>0 ? obj.width : 100)

        if(obj.value)
            inp.val(obj.value)
    }




    // if(obj.subType === 'date'){
    // if(obj.subType2.includes('date')){
    $(obj.subType2).each(function (){
        // console.log('?',this === 'date',this,obj.subType, obj.subType2, inp)
        if(this === 'date')
        CS.addToObserveList({
            callback: () => {
                datepicker(inp[0], CS.dpOptions)
            },
            element: inp[0],
        })
    })

    CS.startTrackingChanges(inp);
    return out.append(inp)
}

export function createInputGroup(){

}

// function startSelect(obj, opts){
//     let x = $(obj).selectize(
//         {...{
//             onChange: function (o) { console.log('??>',o)},
//                 sortField: [{ field: 'text', direction: 'asc' }],
//             // events: {...opts.events, SelectEvents}
//                 // afterChange: (newVal) => {}
//
//         }, ...opts
//     })
//     return x
// }
